module.exports = __webpack_public_path__ + "img/c9.75807cde.jpg";